import {
  listTreeStatistic,
  listForestMap,
  detailForestMap,


  listAnimalTable,
  listAnimalStatistic,
  listAnimalsTypes,
  listAnimalsMap,
  detailAnimalsMap

} from "../../api/goskomles";

export default {
  fetchTreeStatistic({ commit }, a) {
    // возвращает статистику для лесов, если отправить fields=all то вернет всю статитстику
    return new Promise((resolve, reject) => {
      listTreeStatistic(a)
        .then(res => {
          commit("SET_TREE_STATISTIC", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllForestMap({ commit }, a) {
    // возвращает все заповедники для карты
    return new Promise((resolve, reject) => {
      listForestMap(a)
        .then(res => {
          commit("SET_LIST_FORESTS", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchDetailForest({ commit }, a) {
    // возвращает определенный заповедник
    return new Promise((resolve, reject) => {
      detailForestMap(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAnimalStatistic({ commit }, a) {
    // возвращает статистику для животных , 
    return new Promise((resolve, reject) => {
      listAnimalStatistic(a)
        .then(res => {
          commit("SET_ANIMAL_STATISTIC", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAnimalTable({ commit }, a) {
    // возвращает статистику для животных , 
    return new Promise((resolve, reject) => {
      listAnimalTable(a)
        .then(res => {
          commit("SET_ANINAL_TABLE", res.data.results);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAnimalsTypes({ commit }, a) {
    // возвращает список животных для селекта на  карте
    return new Promise((resolve, reject) => {
      listAnimalsTypes(a)
        .then(res => {
          commit("SET_TYPES_AMIMALS", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllAnimalsMap({ commit }, a) {
    // возвращает всех животных для карты
    return new Promise((resolve, reject) => {
      listAnimalsMap(a)
        .then(res => {
          commit("SET_LIST_AMIMALS", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchDetailAnimals({ commit }, a) {
    // возвращает определенный заповедник
    return new Promise((resolve, reject) => {
      detailAnimalsMap(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
